import { useEffect } from 'react';
import type { AgoraRoomLike } from '../../../types';
import { Callback } from '../../../types';

export default function useHandleTrackPublicationFailed(_room: AgoraRoomLike | null, _onError: Callback) {
  useEffect(() => {
    // Agora: no direct equivalent; publish errors surface in connect(). No-op.
  }, [_room, _onError]);
}
